/** @module csi/datasheet/canvasSplash */
define([
	"dojo/_base/declare",
	"dojo/dom-style",
	"dijit/_TemplatedMixin",
	"dijit/_WidgetBase",
	"dijit/_WidgetsInTemplateMixin",
	"dojo/text!../templates/canvasSplash.html",
	"dijit/form/Button"
], function(declare, domStyle, _TemplatedMixin, _WidgetBase, _WidgetsInTemplateMixin, template) {

	return declare([_WidgetBase, _TemplatedMixin, _WidgetsInTemplateMixin], {
		templateString: template,
		canvasCreateBtn: null,
		canvasTemplateBtn: null,

		postCreate: function() {
			if (this.isTemplate) {
				domStyle.set(this.canvasTemplateBtn.domNode, "display", "none");
			}

			this.inherited(arguments);
		},

		_setDisabledAttr(b) {
			this._set("disabled", b);
			this.canvasCreateBtn.set("disabled", b);
			this.canvasTemplateBtn.set("disabled", b);
		}
	});
});